import user from './user/index.vue'
import role from './role/index.vue'
import authority from './authority/index.vue'
export default {
  user,
  role,
  authority
}
